import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { getThoughtProcessPreferences } from "@/lib/thoughtProcessPreferences";

export type GoogleDriveImportOptionsState = {
  mirrorFolders: boolean;
  includeInRag: boolean;
  embedAfterImport: boolean;
};

type GoogleDriveImportOptionsProps = {
  options: GoogleDriveImportOptionsState;
  onChange: (next: GoogleDriveImportOptionsState) => void;
};

export const GoogleDriveImportOptions = React.memo(function GoogleDriveImportOptions({
  options,
  onChange,
}: GoogleDriveImportOptionsProps) {
  const defaults = getThoughtProcessPreferences();

  return (
    <div className="flex flex-wrap gap-4 rounded-md border bg-muted/20 p-3 text-sm">
      <div className="flex items-center gap-2">
        <Checkbox
          id="gd-mirror-folders"
          checked={options.mirrorFolders}
          onCheckedChange={(checked) =>
            onChange({ ...options, mirrorFolders: checked === true })
          }
        />
        <Label htmlFor="gd-mirror-folders" className="font-normal cursor-pointer">
          Mirror folder structure in Library
        </Label>
      </div>
      <div className="flex items-center gap-2">
        <Checkbox
          id="gd-include-rag"
          checked={options.includeInRag}
          onCheckedChange={(checked) =>
            onChange({ ...options, includeInRag: checked === true })
          }
        />
        <Label htmlFor="gd-include-rag" className="font-normal cursor-pointer">
          Include in RAG search
        </Label>
      </div>
      <div className="flex items-center gap-2">
        <Checkbox
          id="gd-embed"
          checked={options.embedAfterImport}
          onCheckedChange={(checked) =>
            onChange({ ...options, embedAfterImport: checked === true })
          }
        />
        <Label htmlFor="gd-embed" className="font-normal cursor-pointer">
          Embed after import
          {!defaults.autoEmbedDocuments && (
            <span className="ml-1 text-muted-foreground">(off by default)</span>
          )}
        </Label>
      </div>
    </div>
  );
});
